'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Caption } from '../../../server/typography/Caption/Caption';
import { useFieldContext } from './FieldContext';
/**
 * Compound member of <Field>. Renders helper text linked into
 * the control's aria-describedby chain via FieldContext.
 */
export function FieldDescription({ children }) {
    const ctx = useFieldContext();
    return (_jsx(Caption, { id: ctx?.descriptionId, children: children }));
}
//# sourceMappingURL=FieldDescription.js.map